import { ImmunisationForm } from "~/components/form/health-profile/ImmunisationForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateImmunisation() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="immunisations">
            <ImmunisationForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
